import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as checkoutActions from '../../stateManagement/engine/actions/CheckoutActions';
import ModalLayout from '../ModalLayout';
import { connect } from 'react-redux';
import { buildIFrameUrl, subscribeToIframeMessages } from '../../utils/CreditCardIFrameUtils';
import { Modal } from 'wix-style-react';

function CreditCardIFrame({ onRequestClose, addPayment, organization, isOpen }) {
  const [state, setState] = useState({
    iframeHeight: 280,
    showSpinner: true,
  });

  useEffect(() => {
    const unsubscribe = subscribeToIframeMessages({
      onHeight: height => {
        setState({ iframeHeight: height });
      },
      onSubmit: token => {
        addPayment({
          paymentValue: {
            type: 'credit',
            tip: 0,
            amount: 0,
            cardToken: token,
          },
        });
        onRequestClose();
      },
      onClose: onRequestClose,
    });
    return () => {
      unsubscribe();
    };
  }, [addPayment, onRequestClose]);

  return (
    <Modal dataHook="modal-new-card-iframe" isOpen={isOpen} onRequestClose={onRequestClose} shouldCloseOnOverlayClick>
      <ModalLayout title="New Card" size="small" onCloseClick={onRequestClose} contentPadding={'0 30px 18px 30px'}>
        <iframe
          src={buildIFrameUrl({
            networks: organization.creditcardsInfo.networks,
            fields: organization.creditcardsInfo.fields,
            countryCode: organization.address.countryCode,
            locale: organization.locale,
          })}
          title="new-credit-card-select"
          style={{
            height: state.iframeHeight + 'px',
            border: 'none',
            margin: '0 auto',
            display: 'block',
            marginBottom: 12,
            width:'100%'
          }}
          className="iframe"
        />
      </ModalLayout>
    </Modal>
  );
}

CreditCardIFrame.propTypes = {
  onRequestClose: PropTypes.func,
  addPayment: PropTypes.func,
  isOpen: PropTypes.bool,
  organization: PropTypes.object,
};

CreditCardIFrame.defaultProps = {
  isOpen: false,
};

function mapStateToProps(state, ownProps) {
  return {
    organization: state.session.organization,
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    ...bindActionCreators(
      {
        addPayment: checkoutActions.addPayment,
      },
      dispatch,
    ),
    ...ownProps,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreditCardIFrame);
